(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.hasAllPanel = this.panels.some((panel) => panel.dataset.panel === 'all');
      this.viewAll = {
        all: this.querySelector('[data-view-all-all]'),
        veg: this.querySelector('[data-view-all-veg]'),
        nonveg: this.querySelector('[data-view-all-nonveg]'),
      };

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      this.select(this.dataset.defaultTab || 'all');
    }

    select(name) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tab === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const key = panel.dataset.panel;
        let visible;

        if (name === 'all') {
          // Use the dedicated "All" collection when one is set.
          // Otherwise fall back to showing both of the other grids.
          visible = this.hasAllPanel ? key === 'all' : key !== 'all';
        } else {
          visible = key === name;
        }

        panel.hidden = !visible;
      });

      Object.keys(this.viewAll).forEach((key) => {
        const link = this.viewAll[key];
        if (!link) return;
        link.hidden = key !== name;
      });
    }

    onKeydown(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();

      const current = this.tabs.indexOf(event.target);
      let next = current;

      if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;

      this.tabs[next].focus();
      this.select(this.tabs[next].dataset.tab);
    }
  }

  if (!customElements.get('collection-tabs')) {
    customElements.define('collection-tabs', CollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
